import { useTranslation } from 'react-i18next';
import {
  NotificationEventTypeListFilterInput,
  SortingDirection,
} from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import { FilterWrapper } from '../../wrapper/filter/wrapper';
import { NotificationPreferencesFilter } from './filter';
import { ContentWrapper } from '../../wrapper/content/wrapper';
import { TableWrapper } from '../../wrapper/table/wrapper';
import { Accordion, Typography } from '@otp/ui';
import { Settings } from '@otp/icons';
import { useNotificationChannels } from 'src/hooks/query/notification/use-notification-channels';
import { useNotificationUnsubscribes } from 'src/hooks/query/notification/use-notification-unsubscribes';
import { useNotificationEventTypes } from 'src/hooks/query/notification/use-notification-event-types';
import styles from './index.module.css';
import clsx from 'clsx';
import { NotificationPreferencesTable } from './table/table';

export const NotificationPreferencesList = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'notification.preferences.list',
  });

  const { filter, defaultFilter, onFilterChange } = useTable<
    NotificationEventTypeListFilterInput,
    Record<string, SortingDirection>
  >();

  const { notificationChannels } = useNotificationChannels();
  const { notificationUnsubscribes } = useNotificationUnsubscribes();
  const { groupedNotificationEventTypes } = useNotificationEventTypes({
    filter,
  });

  const accordionTitle = (category: string) => (
    <Typography
      fontWeight="bold"
      variant="subtitle1"
      color="var(--mui-palette-primary-800)"
      className="pl-2"
    >
      {category}
    </Typography>
  );

  return (
    <>
      <FilterWrapper>
        <NotificationPreferencesFilter
          onSubmit={onFilterChange}
          defaultFilter={defaultFilter}
        />
      </FilterWrapper>

      <ContentWrapper>
        <TableWrapper>
          <Typography variant="subtitle1" className="flex gap-2 mb-4">
            <Settings />
            {t('subtitle')}
          </Typography>
          {Object.keys(groupedNotificationEventTypes).map((category, index) => {
            const eventTypes = groupedNotificationEventTypes[category];
            return (
              <Accordion
                key={category}
                title={accordionTitle(category)}
                variant="contained"
                className={clsx(styles.accordion, 'mb-2 px-0')}
                defaultExpanded={index === 0}
              >
                <NotificationPreferencesTable
                  data={eventTypes}
                  channels={notificationChannels}
                  unsubscribes={notificationUnsubscribes}
                  options={{}}
                />
              </Accordion>
            );
          })}
        </TableWrapper>
      </ContentWrapper>
    </>
  );
};
